'use strict';

angular.module('atex.aceui.application').factory('ApplicationConfigurationService',
['$q', '$rootScope', function($q, $rootScope) {
  var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope) };
  var configurationHandler = atex.aceui.service.ConfigurationService('configuration.json', serviceSettings);

  var configuration = {};

  var initializationDeferred = $q.defer();

  var initializationCompleted = false;
  var initializationInProgress = false;

  function readConfigurationFile() {
    if (!initializationInProgress && !initializationCompleted) {
      initializationInProgress = true;

      configurationHandler.readConfiguration().then(function(config) {
        configuration = config;

        initializationInProgress = false;
        initializationCompleted = true;

        initializationDeferred.resolve();
      }).then(undefined, function(error) {
        initializationDeferred.reject(error);
      });
    }
  }

  return {
    /**
     * Reads the value for the given configuration path from the server-provided configuration.
     *
     * Argument 'configurationPath' - an array which corresponds to the
     * configuration path to read.
     *
     * Argument 'defaultValue' - the default value to use if a value cannot be found
     * at the specified 'configurationPath'. If no configuration can be found, and
     * this argument is omitted, undefined will be returned.
     *
     * Returns a Q-based promise.
     *
     * Resolves the return promise with the configuration data if the operation succeeds.
     * Rejects the return promise with an atex.aceui.error.Error object if the operation fails.
     */
    getConfigurationFor: function(configurationPath, defaultValue) {
      readConfigurationFile();

      return initializationDeferred.promise.then(function() {
        var configValue = atex.aceui.ObjectUtils.getByPath(configuration, configurationPath);
        return typeof configValue !== 'undefined' ? configValue : defaultValue;
      });
    },

    /**
     * Reads the values for the given configuration paths from the server-provided configuration.
     *
     * Argument 'configurationPaths' - an array containing configuration paths to read. The
     * paths are on the same format as for ApplicationConfigurationService.getConfigurationFor.
     *
     * Returns a Q-based promise.
     *
     * Resolves the return promise with the an array of the configuration data if the operation succeeds.
     * Rejects the return promise with an atex.aceui.error.Error object if the operation fails.
     */
    getConfigurationsFor: function(configurationPaths) {
      readConfigurationFile();

      return initializationDeferred.promise.then(function() {
        return configurationPaths.map(function(configPath) {
          return atex.aceui.ObjectUtils.getByPath(configuration, configPath);
        });
      });
    },

    /**
     * Returns the configuration for the service with the given service name.
     *
     * Argument 'serviceName' - the name of the service for which to return the configuration.
     *
     * Returns a Q-based promise.
     *
     * If the operation succeeds the returned promise is resolved with an object like:
     *
     * {
     *   common: {
     *     baseUrl: '/ace'
     *   },
     *
     *   key: 'value',
     *   key2: 'value2'
     * }
     *
     * Property 'common' is an object containing configuration common for all services. Contains
     * the property 'baseUrl' which can be used as a base URL for services.
     *
     * Rejects the returned promise with an atex.aceui.error.Error object if the
     * operation fails.
     */
    getServiceConfigurationFor: function(serviceName) {
      var commonConfigurationKey = 'service/common';
      var serviceConfigurationKey = 'service/' + serviceName;

      return this.getConfigurationsFor([commonConfigurationKey, serviceConfigurationKey]).then(function(configurationValues) {
        var commonConfiguration = configurationValues[0] || {};
        commonConfiguration.baseUrl = commonConfiguration.baseUrl || '/ace';

        var serviceConfiguration = configurationValues[1] || {};

        serviceConfiguration.common = commonConfiguration;

        return serviceConfiguration;
      });
    }
  };
}]);
